import React from "react";

interface SpinSize { big: number; small: number; }

const SpinSizes = {
    // for a larger spinner that is displayed cenetered or instead of a dialog/viewport
    default: { big: 75, small: 5 },
    // for a smaller spinner next to a button
    small: { big: 16, small: 3 },
} as const satisfies Record<string, SpinSize>;

type SizeKey = keyof typeof SpinSizes;

export const SXSpin = (props: { size?: SizeKey, center?: boolean }) => {
    const size = SpinSizes[props.size ?? "default"]
    const sizeStr = `${size.big}px`;
    const span = <span className="spinner" style={{
        width: sizeStr,
        height: sizeStr,
        borderWidth: `${size.small}px`
    }} />;

    if (props.center) {
        return <div className="spinner-parent--center">{span}</div>
    }

    return span;
}
